import Router from 'next/router';

// Component
import PriceContainer from 'components/PriceContainer';

// Utils
import { useImageHandler } from 'utils/custom_hooks';
import truncateString from 'utils/truncate_string';
import { cancelEventBubble } from 'utils/cancel_event_bubble';
import { generateCoverImageUrl } from 'utils/generate_cover_image_url';
import React, { useMemo } from 'react';
import BundleTypeBadge from '../bundles/BundleTypeBadge';
import { truncateText } from 'utils/helper';
import { trackSelectContent } from 'lib/analytics';
import Button from 'components/Button';
import { FONT_TYPES } from 'variables/font_groups';
import { BUTTON_TYPE } from 'constants/button';
import { isMobile } from 'react-device-detect';

export default function CardBundle({ data, handleAddToCart, isAlreadyInCart, filter }) {
  const memoizedOptionList = useMemo(
    () => [data.courseOrganizer?.logo, data.courseOrganizer?.companyLogo],
    [data.courseOrganizer?.logo, data.courseOrganizer?.companyLogo]
  );
  const { currentImage, handleImageToDefault } = useImageHandler({
    optionList: memoizedOptionList,
    data,
  });
  let month = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const handleRedirect = () => {
    //    const url = !isProduct ? 'courses/' + slug : 'products/' + slug;
    const url = `bundles/${data.slug}`;
    trackSelectContent({
      page_type: 'category',
      item_id: data.bundleId,
      item_name: data.name,
      item_category: data.bundleType || 'unknown',
      list_name: 'bundles',
    });
    Router.push(url);
  };

  const handleAddToCartClick = (e) => {
    cancelEventBubble(e);
    handleAddToCart();
  };

  const handleMoreInformationClick = (e) => {
    cancelEventBubble(e);
    handleRedirect();
  };

  return (
    <div
      className="row cursor-pointer category-card-wrapper card-border-bottom mt-4 rounded card-bundle"
      onClick={() => !isMobile ? handleRedirect() : {}}
    >
      <div className={`d-flex flex-column ${filter ? 'col-6 col-md-4' : 'col-md-3'}`}>
        <div className="category-card-image-container">
          <img className="category-card-image" src={generateCoverImageUrl(data.picture)} alt="Bedroom organization" />
        </div>
        {!isMobile && (
          <Button
            type={isAlreadyInCart ? BUTTON_TYPE.addedToCartDarker : BUTTON_TYPE.primary}
              variety={3}
              fontType={FONT_TYPES.textBody}
              className="mt-2 fw-normal category-card-button"
              onClick={handleAddToCartClick}
          >
            {isAlreadyInCart ? 'Added to cart' : 'Add to cart'}
          </Button>
        )}
      </div>
      <div className={`d-flex flex-column justify-content-between ${filter ? 'col-6 col-md-8' : 'col-12 col-md-9'}`}>
        <div>
          <p className="font-weight-600 cursor-pointer category-card-title title-2">{data.name}</p>
          <div style={{ marginBottom: '1.1rem' }}>
            <BundleTypeBadge bundleType={data.bundleType} extraClass={isMobile ? 'font-size-12' : ''} />
          </div>
          <div className="category-card-user-picture-container">
            <img
              className="category-card-user-picture"
              src={data.provider.path}
              onError={() => handleImageToDefault()}
              alt={data.provider.name}
            />
          </div>
          <p className="font-size-12 text-secondary d-none d-lg-flex">
            Published: {month[new Date(data.createdAt).getMonth()]} {new Date(data.createdAt).getDate()},{' '}
            {new Date(data.createdAt).getFullYear()}
          </p>
          <p
            className="font-size-16 d-none d-lg-flex flex-lg-column custom-text-body"
            dangerouslySetInnerHTML={{ __html: truncateText(data.description, 200, true) }}
          />
        </div>
        <div className="mt-4 mt-lg-0">
          <div className="d-flex justify-content-between align-items-start flex-lg-row flex-column mb-4 mb-lg-0">
            <span className="category-card-user-name" style={{ color: '#666666' }}>
              By: {data.provider?.name ? data.provider.name : 'KPI Institute'}
            </span>
          </div>
          <PriceContainer
            variableDiscount={[parseFloat(data.discount), parseFloat(data.discount?.['$numberDecimal'])]}
            variablePrice={[parseFloat(data.price), parseFloat(data.price?.['$numberDecimal'])]}
            courseOrganizer={''}
            isLarge
          />
        </div>
      </div>
      {isMobile && (
        <div className="row m-0">
          <div className="col-6 mt-4">
            <Button
              type={isAlreadyInCart ? BUTTON_TYPE.addedToCartDarker : BUTTON_TYPE.primary}
              variety={3}
              fontType={FONT_TYPES.textBody}
              style={{height: '45px'}}
              className="mt-0 fw-normal category-card-button"
              onClick={handleAddToCartClick}
            >
              {isAlreadyInCart ? 'Added to cart' : 'Add to cart'}
            </Button>
            </div>
            <div className='col-6 mt-4'>
            <Button
              variety={4}
              fontType={FONT_TYPES.subHeading}
              type={BUTTON_TYPE.secondary}
              style={{height: '45px'}}
              className="category-card-button p-0 mt-0"
              onClick={handleMoreInformationClick}
            >
              More Information
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
